__turbopack_context__.v({
  "burger": "navbar-module-scss-module__rsUhra__burger",
  "burgerLine": "navbar-module-scss-module__rsUhra__burgerLine",
  "flex": "navbar-module-scss-module__rsUhra__flex",
  "glow": "navbar-module-scss-module__rsUhra__glow",
  "indicator": "navbar-module-scss-module__rsUhra__indicator",
  "inner": "navbar-module-scss-module__rsUhra__inner",
  "logoBlock": "navbar-module-scss-module__rsUhra__logoBlock",
  "logoIcon": "navbar-module-scss-module__rsUhra__logoIcon",
  "logoText": "navbar-module-scss-module__rsUhra__logoText",
  "menuBtn": "navbar-module-scss-module__rsUhra__menuBtn",
  "menuBtnOpen": "navbar-module-scss-module__rsUhra__menuBtnOpen",
  "mobileMenu": "navbar-module-scss-module__rsUhra__mobileMenu",
  "mobileMenuClose": "navbar-module-scss-module__rsUhra__mobileMenuClose",
  "mobileMenuCloseIcon": "navbar-module-scss-module__rsUhra__mobileMenuCloseIcon",
  "mobileMenuCta": "navbar-module-scss-module__rsUhra__mobileMenuCta",
  "mobileMenuFooter": "navbar-module-scss-module__rsUhra__mobileMenuFooter",
  "mobileMenuHeader": "navbar-module-scss-module__rsUhra__mobileMenuHeader",
  "mobileMenuInner": "navbar-module-scss-module__rsUhra__mobileMenuInner",
  "mobileMenuLogo": "navbar-module-scss-module__rsUhra__mobileMenuLogo",
  "mobileMenuLogoIcon": "navbar-module-scss-module__rsUhra__mobileMenuLogoIcon",
  "mobileMenuLogoText": "navbar-module-scss-module__rsUhra__mobileMenuLogoText",
  "mobileMenuOpen": "navbar-module-scss-module__rsUhra__mobileMenuOpen",
  "mobileMenuSocialLink": "navbar-module-scss-module__rsUhra__mobileMenuSocialLink",
  "mobileMenuSocials": "navbar-module-scss-module__rsUhra__mobileMenuSocials",
  "mobileNavBtn": "navbar-module-scss-module__rsUhra__mobileNavBtn",
  "mobileNavBtnActive": "navbar-module-scss-module__rsUhra__mobileNavBtnActive",
  "mobileOverlay": "navbar-module-scss-module__rsUhra__mobileOverlay",
  "mobileOverlayOpen": "navbar-module-scss-module__rsUhra__mobileOverlayOpen",
  "nav": "navbar-module-scss-module__rsUhra__nav",
  "navBtn": "navbar-module-scss-module__rsUhra__navBtn",
  "navBtnActive": "navbar-module-scss-module__rsUhra__navBtnActive",
  "navItems": "navbar-module-scss-module__rsUhra__navItems",
  "wrapper": "navbar-module-scss-module__rsUhra__wrapper",
});
